module.exports = __webpack_public_path__ + "cello-player.55a5a97d.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/images/neighborhood/full/cello-player.jpg
// module id = 653
// module chunks = 0